import { Button } from "../../components/ui/button";
import { Trash2 } from "lucide-react";

const UsersTab = ({ users, currentUserId, safeFormat, onDeleteUser }) => {
  return (
    <div className="bg-[#0B0F19] rounded-xl border border-[#D4AF37]/10 overflow-hidden">
      <div className="p-4 border-b border-[#D4AF37]/10">
        <h3 className="font-['Playfair_Display'] text-xl text-white">All Users</h3>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full" data-testid="users-table">
          <thead className="bg-white/5">
            <tr>
              <th className="text-left p-4 text-white/50 text-sm font-medium">Name</th>
              <th className="text-left p-4 text-white/50 text-sm font-medium">Email</th>
              <th className="text-left p-4 text-white/50 text-sm font-medium">Role</th>
              <th className="text-left p-4 text-white/50 text-sm font-medium">Status</th>
              <th className="text-left p-4 text-white/50 text-sm font-medium">Joined</th>
              <th className="text-left p-4 text-white/50 text-sm font-medium">Actions</th>
            </tr>
          </thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.id} className="border-t border-white/5">
                <td className="p-4 text-white">{u.first_name} {u.last_name}</td>
                <td className="p-4 text-white/70">{u.email}</td>
                <td className="p-4">
                  <span className={`px-2 py-1 rounded text-xs font-medium ${u.role === 'admin' ? 'bg-[#D4AF37]/20 text-[#D4AF37]' : u.role === 'team_member' ? 'bg-blue-500/20 text-blue-400' : 'bg-white/10 text-white/60'}`}>
                    {u.role}
                  </span>
                </td>
                <td className="p-4">
                  <span className={`px-2 py-1 rounded text-xs font-medium ${u.membership_status === 'active' ? 'bg-[#047857]/20 text-[#047857]' : 'bg-white/10 text-white/40'}`}>
                    {u.membership_status || 'None'}
                  </span>
                </td>
                <td className="p-4 text-white/50 text-sm">{safeFormat(u.created_at, 'MMM d, yyyy')}</td>
                <td className="p-4">
                  {u.id !== currentUserId && (
                    <Button 
                      variant="ghost" 
                      size="sm"
                      onClick={() => onDeleteUser(u.id, u.email)}
                      className="text-red-400 hover:text-red-300 hover:bg-red-500/10"
                      data-testid={`delete-user-${u.id}`}
                    >
                      <Trash2 className="w-4 h-4" />
                    </Button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default UsersTab;
